<template>
  <div>
    <template v-if="!$route.params.service_id">
      <b-button-group size="sm" class="w-100 table-actions">
        <b-dropdown
          size="sm"
          variant="table"
          v-if="
            !$route.params.service_id &&
            checkActionAllow('show') &&
            row.item.reference_order_type_id == 2
          "
          :id="'dropdown_' + row.item.id"
          :offset="!stacked ? '' : -105"
          dropleft
          right
          :boundary="!stacked ? '.b-table' : 'scrollParent'"
          :no-flip="!stacked ? true : false"
          @show="dropDownVisibilityControl('dropdown_' + row.item.id)"
          @hidden="dropDownVisibilityControl('dropdown_' + row.item.id, false)"
        >
          <template #button-content>
            <b-icon icon="gear-wide-connected" scale="1.2"></b-icon>
          </template>

          <b-dropdown-item-button
            v-if="!$route.params.service_id && checkActionAllow('show')"
            @click="openOrderSidebar(row.item.id)"
          >
            Карточка поставки
          </b-dropdown-item-button>
          <b-dropdown-divider></b-dropdown-divider>
          <template v-if="checkActionAllow('make-bill')">
            <b-dropdown-group header="Финансы">
              <b-dropdown-item-button
                @click="openOrderSidebar(row.item.id, '', {tab: 'order-finance'})"
              >
                <span>
                  <b-icon icon="blank" aria-hidden="true"></b-icon>
                  Счета
                </span>
              </b-dropdown-item-button>
              <b-dropdown-item-button
                @click="openOrderSidebar(row.item.id, '', {tab: 'order-finance-requests'})"
              >
                <span>
                  <b-icon icon="blank" aria-hidden="true"></b-icon>
                  Запросы
                </span>
              </b-dropdown-item-button>
            </b-dropdown-group>
            <b-dropdown-divider></b-dropdown-divider>
          </template>
          <b-dropdown-item-button
            @click="openOrderSidebar(row.item.id, '', {tab: 'order-documents'})"
          >
            Документы
          </b-dropdown-item-button>
          <b-dropdown-divider></b-dropdown-divider>
          <b-dropdown-item-button
            v-if="
              checkActionAllow('distribute-services') &&
              row.item.reference_order_type_id == 2 &&
              row.item.reference_status_id != 361
            "
            @click="openServiceDistributionModal(row.index)"
          >
            Перераспределить
          </b-dropdown-item-button>
          <b-dropdown-divider />
          <b-dropdown-item-button
            v-if="checkActionAllow('edit') && row.item.reference_status_id != 361"
            @click="openOrderSidebar(row.item.id, {edit: true})"
          >
            Редактировать
          </b-dropdown-item-button>
          <b-dropdown-item-button @click="copyItem(row.index)">
            Скопировать
          </b-dropdown-item-button>
          <b-dropdown-item-button
            v-if="checkActionAllow('score-order') && row.item.reference_status_id == 361"
            @click="scoreOrder(row.index)"
          >
            Оценить поставку
          </b-dropdown-item-button>
          <template v-if="checkActionAllow('delete')">
            <b-dropdown-divider></b-dropdown-divider>
            <b-dropdown-item-button
              variant="danger"
              @click="deleteItem(row.index)"
            >
              <b-icon icon="trash-fill" aria-hidden="true"></b-icon>
              Удалить
            </b-dropdown-item-button>
          </template>
        </b-dropdown>
        <b-button
          variant="table"
          v-if="!$route.params.service_id && checkActionAllow('show')"
          @click="openOrderSidebar(row.item.id)"
        >
          <i class="far fa-eye"></i>
        </b-button>

        <b-button
          variant="table"
          v-if="
            checkActionAllow('edit') &&
            row.item.reference_order_type_id == 1 &&
            row.item.reference_status_id != 362
          "
          @click="openOrderSidebar(row.item.id, {edit: true})"
        >
          <i class="fas fa-pencil-alt"></i>
        </b-button>

        <b-button
          variant="table"
          v-if="
            (checkActionAllow('delete') &&
              (row.item.reference_order_type_id == 1 ||
                row.item.sum_payment == 0)) ||
            (checkActionAllow('leads-delete') &&
              row.item.reference_sources_id == 23 &&
              row.item.short_order == 1 &&
              row.item.reference_order_type_id == 1)
          "
          @click="deleteItem(row.index)"
        >
          <i class="fas fa-trash text-danger"></i>
        </b-button>
      </b-button-group>
    </template>
    <div>
      <template v-if="
        checkActionAllow('make-order-supply') &&
        row.item.reference_order_type_id == 1 &&
        row.item.reference_status_id != 362 &&
        !row.item.short_order
      ">
        <b-button
          variant="primary"
          class="table_actions_supply mt-2 action-chip action-chip--accent w-100"
          :disabled="row.item.reference_status_id == 541"
          :title="row.item.reference_status_id == 541 ? 'Из этого статуса заказ нельзя перевести в Поставку' : ''"
          @click="makeOrderSupply(row.index)"
        >
          <span class="table_actions_supply-title action-chip__label">
            <i v-if="row.item.loading" class="fas fa-spinner fa-spin d-block"></i>
            <span v-else>В поставку</span>
          </span>
        </b-button>      
      </template>
      <template v-if="
        checkActionAllow('distribute-services') &&
        row.item.reference_order_type_id == 2 &&
        checkIfDistributed(row.item) &&
        row.item.reference_status_id != 361
      ">
        <span
          class="table_distribute-services mt-2 action-chip"
          @click="openServiceDistributionModal(row.index)"
        >
          <span class="table_distribute-services-title action-chip__label">Распределить</span>
        </span>    
      </template>
    </div>
    <template v-if="$route.params.service_id">
      <div 
        class="table_actions_create_order" 
        @click="openOrderSidebar(row.item.id, '', {tab: $route.params.service_id})"
      >
        <span class="table_actions_create_order-title">В&nbsp;заказ&nbsp;</span>
      </div>
    </template>
  </div>
</template>
<script>
import { checkActionAllow } from "@/mixins";
import { openOrderSidebar } from "@/mixins/openOrderSidebar";

export default {
  props: {
    row: { type: Object, required: true }, // Row of table
    actionAllows: {
      type: Array,
      required: false,
      default: function () {
        return [];
      },
    }, // Array of rules for action allows
  },
  mixins: [
    checkActionAllow, 
    openOrderSidebar
  ],
  data() {
    return {};
  },
  computed: {
    stacked() {
      const stackedBreakpoints = ["sm"];
      return stackedBreakpoints.includes(this.$mq);
    },
    responsive() {
      const responsiveBreakpoints = ["md", "lg", "xl"];
      return responsiveBreakpoints.includes(this.$mq);
    },
  },
  methods: {
    deleteItem(index) {
      this.$emit("universalEmit", "delete", index);
    },
    copyItem(index) {
      this.$emit("universalEmit", "copy", index);
    },
    scoreOrder(index) {
      this.$emit("universalEmit", "score", index);
    },
    createOrderBillFromAction(index) {
      this.$emit("universalEmit", "createOrderBillFromAction", index);
    },
    createOrderFinanceRequestFromAction(index) {
      this.$emit("universalEmit", "createOrderFinanceRequestFromAction", index);
    },
    openOrderDocumentsFromAction(index) {
      this.$emit("universalEmit", "openOrderDocumentsFromAction", index);
    },
    makeOrderSupply(index) {
      this.$emit("universalEmit", "makeOrderSupply", index);
    },
    openServiceDistributionModal(index) {
      this.$emit("universalEmit", "openServiceDistributionModal", index);
    },
    checkIfDistributed(item) {
        const uniqueServiceIds = [...new Set(item.service_users.map(user => user.service_id))];

      if (item.service_users && item.selected_services) {
        if (uniqueServiceIds.length == item.selected_services.length) {
          return false;
        }
      }
      return true;
    },
    dropDownVisibilityControl(id, show = true) {
      if (!this.stacked) {
        const el = document.getElementById(id);
        const parent = el.closest(".b-table");
        const allSticky = parent.querySelectorAll("td.b-table-sticky-column");

        if (show) {
          // parent.style.minHeight = '400px'
          // parent.style.overflowY = 'hidden'
          allSticky.forEach((sticky) => {
            sticky.style.zIndex = "0";
          });
        } else {
          // parent.style.minHeight = 'auto'
          // parent.style.overflowY = 'auto'
          allSticky.forEach((sticky) => {
            sticky.style.zIndex = "2";
          });
        }
        el.closest("td.b-table-sticky-column").style.zIndex = "2";
      }
    }
  },
};
</script>

